import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { RecordsTab } from "@/components/admin/reference-data/RecordsTab";
import { VersionsTab } from "@/components/admin/reference-data/VersionsTab";

/** Uma tabela do tipo: registros (com edição) ou versões, na mesma aba. */
export function ConfigTypeTableTab({
  tableName,
  onOpenPackageReleases,
}: {
  tableName: string;
  onOpenPackageReleases: () => void;
}) {
  const { t } = useTranslation();
  const [view, setView] = useState<"records" | "versions">("records");
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="inline-flex rounded-md border border-[#e8ebf0] p-0.5">
          <Button
            size="sm"
            variant={view === "records" ? "navy" : "ghost"}
            onClick={() => setView("records")}
          >
            {t("Records")}
          </Button>
          <Button
            size="sm"
            variant={view === "versions" ? "navy" : "ghost"}
            onClick={() => setView("versions")}
          >
            {t("Versions")}
          </Button>
        </div>
      </div>
      {view === "records" ? (
        <RecordsTab
          tableName={tableName}
          title={tableName}
          onStaged={() => setView("versions")}
        />
      ) : (
        <VersionsTab
          tableName={tableName}
          onOpenPackageReleases={onOpenPackageReleases}
        />
      )}
    </div>
  );
}
